import { __rest } from "tslib";
import React from 'react';
import Button from './Button';
export default function CircleButton(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Button, Object.assign({ alignItems: "center", borderRadius: "50%", display: "flex", justifyContent: "center", kind: "ghost", px: 0, size: 1, tag: "div", width: 30 }, props), children));
}
